// extracted by mini-css-extract-plugin
module.exports = {"store":"Category_store__1cCz9","products":"Category_products__CyDUl","brandLogo":"Category_brandLogo__E7uN4"};